import { createContext } from 'react';


// Product Context
export default createContext([]);